var path = 'tenant/tenant-card.tpl.html';
var html = " <div class=tb-uppercase>{{ item | contactShort }}</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/tenant/tenant-card.tpl.html
// module id = 1522
// module chunks = 1